<div class="component-container">
  <label [for]="id">
    @if (loading) {
      <i class="pi pi-spin pi-spinner color-primary" style="font-size: 1rem"></i>
    }
    @if (!loading) {
      <i aria-hidden="true" [class]="class"></i>
    }
    @if (!loading) {
      <input type="file" accept=".xlsx" class="sr-only" [id]="id" (change)="onChange($event)" />
    }
  </label>
</div>